<template>
  <el-dropdown ref="elDropdown" trigger="click" :hide-on-click="false" placement="bottom-start" @visible-change="visibleChange">
    <div class="el-select" @click="packup">
      <div class="el-select__tags" v-if="multiple" ref="tags" :style="{ 'max-width': inputWidth - 32 + 'px', width: '100%', zIndex: 9 }">
        <span v-if="collapseTags && selected.length">
          <el-tag :closable="!selectDisabled" :size="collapseTagSize" :hit="selected[0].hitState" type="info" @close="deleteTag($event, selected[0])" disable-transitions>
            <span class="el-select__tags-text">{{ selected[0].currentLabel }}</span>
          </el-tag>
          <el-tag v-if="selected.length > 1" :closable="false" :size="collapseTagSize" type="info" disable-transitions>
            <span class="el-select__tags-text">+ {{ selected.length - 1 }}</span>
          </el-tag>
        </span>
        <transition-group @after-leave="resetInputHeight" v-if="!collapseTags">
          <el-tag v-for="item in selected" :key="getValueKey(item)" :closable="!selectDisabled" :size="collapseTagSize" :hit="item.hitState" type="info" @close="deleteTag($event, item)"
            disable-transitions>
            <span class="el-select__tags-text">{{ item.currentLabel }}</span>
          </el-tag>
        </transition-group>
        <input type="text" class="el-select__input ml-10" :class="[selectSize ? `is-${ selectSize }` : '']" :disabled="selectDisabled" :autocomplete="autoComplete || autocomplete" @focus="handleFocus"
          @blur="softFocus = false" @keyup="managePlaceholder" @keydown="resetInputState" @keydown.down.prevent="handleNavigate('next')" @keydown.up.prevent="handleNavigate('prev')"
          @keydown.enter.prevent="selectOption" @keydown.esc.stop.prevent="visible = false" @keydown.delete="deletePrevTag" @keydown.tab="visible = false" @compositionstart="handleComposition"
          @compositionupdate="handleComposition" @compositionend="handleComposition" v-model="query" @input="debouncedQueryChange" v-if="filterable"
          :style="{ 'flex-grow': '1', width: inputLength + 'px', 'max-width': inputWidth - 42 + 'px' }" ref="input">
        <!-- :style="{ 'flex-grow': '1',width: inputLength / (inputWidth - 32) + '%', 'max-width': inputWidth - 42 + 'px' }" ref="input"> -->
      </div>

      <el-input ref="reference" v-model="selectedLabel" :placeholder="currentPlaceholder" readonly size="large"></el-input>
      <!-- <el-input
      ref="reference"
      v-model="selectedLabel"
      type="text"
      :placeholder="currentPlaceholder"
      :name="name"
      :id="id"
      :autocomplete="autoComplete || autocomplete"
      :size="selectSize"
      :disabled="selectDisabled"
      :readonly="readonly"
      :validate-event="false"
      :class="{ 'is-focus': visible }"
      :tabindex="(multiple && filterable) ? '-1' : null"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="debouncedOnInputChange"
      @keydown.native.down.stop.prevent="handleNavigate('next')"
      @keydown.native.up.stop.prevent="handleNavigate('prev')"
      @keydown.native.enter.prevent="selectOption"
      @keydown.native.esc.stop.prevent="visible = false"
      @keydown.native.tab="visible = false"
      @compositionstart="handleComposition"
      @compositionupdate="handleComposition"
      @compositionend="handleComposition"
      @mouseenter.native="inputHovering = true"
      @mouseleave.native="inputHovering = false">
      <template slot="prefix" v-if="$slots.prefix">
        <slot name="prefix"></slot>
      </template>
      <template slot="suffix">
        <i v-show="!showClose" :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"></i>
        <i v-if="showClose" class="el-select__caret el-input__icon el-icon-circle-close" @click="handleClearClick"></i>
      </template>
    </el-input> -->

      <div class="control fx-none fx-p-center">
        <div :class="['packup',{'is-opened':isOpen}]">
          <slot v-if="$slots.hideBtn" name="hideBtn" />
          <i v-else class="el-select__caret el-input__icon el-icon-arrow-down"></i>
        </div>
      </div>
    </div>

    <el-dropdown-menu slot="dropdown">
      <div class="my-dropdown">
        <el-scrollbar v-if="data.length" ref="scrollbar" wrap-class="scrollbar-wrapper scrollbar-wrapper-maxheight">
          <el-tree ref="tree" style="min-width: 200px;" :data="data" :props="config" :show-checkbox="showCheckbox" :check-strictly="checkStrictly" :nodeKey="nodeKey" :expand-on-click-node="false"
            :filter-node-method="filterNode" @check="treeCheck">
          </el-tree>
        </el-scrollbar>
        <div v-else style="width: 200px;text-align:center;color:#999;">数据加载中</div>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
const DefaultProps = {
  value: 'value',
  label: 'label',
  children: 'children',
  disabled: 'disabled',
};
const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};
// import { getTagList, searchTagGroup } from '@/views/labelManagement/api/index.js'
import { Select } from 't-tyui'
import Node from '@/components/D3Tree/nodeClass'
import { flattenTree } from '@/utils/util'
import merge from '@/utils/merge';
export default {
  name: 'TreeDropdown',
  components: {

  },
  mixins: [Select],
  // model: {
  //   prop: 'selectValue',
  //   event: 'selectChange'
  // },
  props: {
    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    defaultProps: {
      type: Object,
      default: () => ({
        children: 'children',
        label: 'label'
      })
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    nodeKey: {
      type: String,
      default: "",
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        if (this.multiple) {
          this.resetInputHeight();
          if ((val && val.length > 0) || (this.$refs.input && this.query !== '')) {
            this.currentPlaceholder = ''
          } else {
            this.currentPlaceholder = this.cachedPlaceHolder;
          }
          if (this.filterable && !this.reserveKeyword) {
            this.query = ''
            this.handleQueryChange(this.query)
          }
        }
        this.setSelected()
        if (this.filterable && !this.multiple) {
          this.inputLength = 20
        }
        if (!valueEquals(val, oldVal)) {
          this.dispatch('ElFormItem', 'el.form.change', val)
        }

        val && this.$nextTick(() => {
          this.$refs.tree?.setCheckedNodes(val)
        })
      }
    },
    data: {
      immediate: true,
      handler: function (val, oldVal) {
        const newVal = this.$lodash.cloneDeep(val)
        const root = {}
        root.list = newVal.map(nodeData => new Node(nodeData, this.config))
        const result = flattenTree(newVal, this.config.children)
        root.selectFlatten = result
        root.selectFlattenMap = result.reduce((p, v) => (p[v.value] = v, p), {})
        // result.forEach((e, i) => {
        //   if (!root['select' + e.level]) root['select' + e.level] = []
        //   root['select' + e.level].push(e)
        // })
        this.root = root
      }
    },
    query(val) {
      this.$refs.tree.filter(val)
    },
  },
  data() {
    return {
      isOpen: false,
      selected: this.multiple ? [] : {},
      popupWidth: 0
      // root: null
    }
  },
  computed: {
    config() {
      return merge({ ...DefaultProps }, this.defaultProps || {})
    },
  },
  mounted() {
    // const self = this.$refs.elDropdown
    // this.$refs.elDropdown.handleClick = function () {
    //   if (self.triggerElm.disabled) return
    //   self.show()
    // }
    // this.$refs.elDropdown.initDomOperation()
    // this.searchTagGroup()
  },
  methods: {
    // 重写原方法
    resetInputHeight() {
      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(() => {
        if (!this.$refs.reference) return;
        let inputChildNodes = this.$refs.reference.$el.childNodes;
        let input = [].filter.call(inputChildNodes, item => item.tagName === 'INPUT')[0];
        const tags = this.$refs.tags;
        const tagsHeight = tags ? Math.round(tags.getBoundingClientRect().height) : 0;
        const sizeInMap = this.initialInputHeight || 40;
        input.style.height = this.selected.length === 0
          ? sizeInMap + 'px'
          : Math.max(
            tags ? (tagsHeight + (tagsHeight > sizeInMap ? 6 : 0)) : 0,
            sizeInMap
          ) + 'px';
        if (this.$refs.elDropdown.visible && this.emptyText !== false) {
          this.broadcast('ElDropdownMenu', 'updatePopper');
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1;
    },
    getParentParams(nodes) {
      if (!this.root) return []
      const lv = []
      const parentParams = []
      const self = this
      nodes.forEach(e => {
        const level = this.root.selectFlattenMap[e.value].level
        const idx = level - 1
        if (!lv[idx]) lv[idx] = []
        lv[idx].push(e)
      })

      const maxLevel = lv.length

      function delFn(index = 0, children) {
        const idx = index + 1
        if (children) {
          lv[index] = lv[index]?.filter(e => {
            if (children.some(c => c.value == e.value)) {
              idx < maxLevel && delFn(idx, e[self.config.children || 'children'])
              return false
            }
            return true
          }) || []
        }
      }
      function getLevelHigh(index = 0) {
        const idx = index + 1
        lv[index]?.forEach(e => {
          parentParams.push(e)
          idx < maxLevel && delFn(idx, e[self.config.children || 'children'])
        })
        idx < maxLevel && getLevelHigh(idx)
      }
      getLevelHigh()
      return parentParams
    },
    setSelected() {
      if (!this.root) return
      if (!this.multiple) {
        let option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      let result = [];
      if (Array.isArray(this.value)) {
        if (this.checkStrictly) {
          this.value.forEach(value => {
            result.push(this.getOption(value));
          });
        } else {
          // 只保留父级
          this.getParentParams(this.value).forEach(value => {
            result.push(this.getOption(value))
          })
        }
      }
      this.selected = result
      this.$nextTick(() => {
        this.resetInputHeight()
      });
    },
    getOption(value) {
      let option;
      const isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      const isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
      const isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

      for (let i = this.cachedOptions.length - 1; i >= 0; i--) {
        const cachedOption = this.cachedOptions[i];
        const isEqual = isObject
          ? getValueByPath(cachedOption.value, this.valueKey) === getValueByPath(value, this.valueKey)
          : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      let label = (!isObject && !isNull && !isUndefined)
        ? String(value) : '';

      if (isObject) {
        label = value[this.config.label]
      }
      let newOption = {
        value: value,
        currentLabel: label
      };
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    deleteTag(event, tag) {
      let index = this.selected.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        const value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    async searchTagGroup() {
      const [err, res] = await this.$reqFn(searchTagGroup, {})
      if (res && res.code === 200) {
        this.tagGroupData = (res.data.voList || []).map(e => {
          let newChild = []
          if (e.type !== 'TAG') {
            newChild = (e.childList || []).filter(e => !e.type)
            console.log('newChild', newChild)
            return { ...e, childList: newChild.map(c => ({ ...c, childList: [] })) }
          }
          return e
        })
      }
    },
    treeCheck(data, { checkedNodes, checkedKeys }) {
      let result = checkedNodes
      if (!this.checkStrictly) {
        result = []
        // 只保留父级
        this.getParentParams(checkedNodes).forEach(value => {
          result.push(value)
        })
      }
      this.$emit('input', result)
      this.$emit('change', result)
      this.selectedLabel = ""
    },
    handleNodeClick(val) {
      this.$refs.elDropdown.visible = false
      this.$emit('selectChange', val.id)
      this.$emit('change', val)
    },

    packup() {
      this.isOpen = true
    },
    changeHandle(item) {
      console.log(item)
    },
    visibleChange(val) {
      this.isOpen = val
    }
  }
}
</script>

<style scoped lang="scss">
.fx-wrap {
  flex-wrap: wrap;
}
/deep/ .scrollbar-wrapper-maxheight {
  max-height: 308px;
  padding-bottom: 10px;
}
.custom-tree-node {
  // width: 158px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.small-select {
  width: 200px;
  position: relative;
  cursor: pointer;
}
.el-select {
  width: 100%;
}
.my-dropdown {
  /deep/ .el-tree {
    width: 100%;
    padding: 0 16px;
  }
}
.control {
  width: 20px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  .el-select__caret {
    right: 10px;
    height: 36px;
    position: relative;
    color: rgb(134, 144, 156) !important;
  }

  .packup {
    user-select: none;
    // color: #2f4bdd;
    position: relative;
    // width: 100%;
    cursor: pointer;
    &.is-opened .el-select__caret {
      transform: rotate(180deg);
    }
  }
}
// ::v-deep .el-input__inner {
//   border-top-left-radius: 0;
//   border-bottom-left-radius: 0;
//   cursor: pointer;
//   position: relative;
//   margin-left: -1px;
//   &:hover,
//   &:focus,
//   &:active {
//     z-index: 1;
//   }
// }
.control .el-select__caret {
  z-index: 2;
}
::v-deep .el-tree-node__content {
  height: 36px;
  &:hover {
    background: transparent;
  }
}

::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: transparent !important;
}
</style>
